module.exports = __webpack_public_path__ + "img/15MGKlq2K_DhuqHGMT0M9H.6b020337.svg";